import { useEffect, useState } from "react";
import '../dashboard-components/loader.css';
import { useNavigate } from "react-router-dom";
import server from "../api/server.js";
import AppsManagement from "../dashboard-components/dashboard/apps/AppsManagement.jsx";
import ConversationRecords from "../dashboard-components/dashboard/calls/ConversationRecords.jsx"
import CustomerRecords from "../dashboard-components/dashboard/customers/CustomerRecords.jsx";
import EventRecords from "../dashboard-components/dashboard/events/EventRecords.jsx";
import EventDetails from "../dashboard-components/dashboard/events/EventDetails.jsx";
import DataSourcesPage from "../dashboard-components/dashboard/data_sources/DataSourcesPage.jsx"
import ContactsPage from "../dashboard-components/dashboard/contacts/ContactsPage.jsx"
import OrganizationSettingsPage from "../dashboard-components/dashboard/projects_and_org/OrganizationSettingsPage.jsx"
import ProjectSettingsPage from "../dashboard-components/dashboard/projects_and_org/ProjectSettingsPage.jsx"
import ProjectStatusComponent from "../dashboard-components/dashboard/projects_and_org/ProjectStatusComponent.jsx"
import AgentFeedbackOverall from "../dashboard-components/dashboard/agent_feedback/AgentFeedbackOverall.jsx";
import AgentFeedbackAgentWise from "../dashboard-components/dashboard/agent_feedback/AgentFeedbackAgentWise.jsx"
import AgentFeedbackTeamWise from "../dashboard-components/dashboard/agent_feedback/AgentFeedbackTeamWise.jsx"
import ConcernQueries from "../dashboard-components/dashboard/concerns_queries/ConcernQueries.jsx";
import AgentFeedbackTraining from "../dashboard-components/dashboard/agent_feedback/AgentFeedbackTraining.jsx";
import AgentFeedbackReports from "../dashboard-components/dashboard/agent_feedback/AgentFeedbackReports.jsx";
import BusinessInsights from "../dashboard-components/dashboard/business_insight/BusinessInsights.jsx";
import BillingDashboard from "../dashboard-components/dashboard/billing/BillingDashboard.jsx";
import HomeScreen from "../dashboard-components/dashboard/home/HomeScreen.jsx"
import CallDetails from "../dashboard-components/dashboard/calls/CallDetails.jsx";
import CustomerDetails from "../dashboard-components/dashboard/customers/CustomerDetails.jsx"
import IndividualReport from "../dashboard-components/dashboard/agent_feedback/IndividualReport.jsx"
import IndividualTraining from "../dashboard-components/dashboard/agent_feedback/IndividualTraining.jsx"
import FormsList from "../dashboard-components/forms/FormsList.jsx"
import DeveloperHubConfiguration from "../dashboard-components/dashboard/developer_hub/DeveloperHubConfiguration.jsx"
import DeveloperHubDocumentation from "../dashboard-components/dashboard/developer_hub/DeveloperHubDocumentation.jsx"
import VoiceAgentsDashboard from "../voice-agents-components/dashboard/home/VoiceAgentsDashboard.jsx"
import ReportsDashboard from "../dashboard-components/dashboard/reports/ReportsDashboard.jsx"

const Dashboard = ({ selectedMenu, subSelectedMenu, selectedOptions, dashNum, openContact, setOpenContact, setSelectedMenu, selectedClientId }) => {
  const [iframeUrl, setIframeUrl] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [comingSoon, setComingSoon] = useState(false);
  const [email, setEmail] = useState(null)
  const [showApps, setShowApps] = useState(false)
  const navigate = useNavigate();
  const [role] = useState(()=> {
    const userCookie = getCookie('dashboard_login_user_creds');
    if (userCookie) {
      const userData = JSON.parse(userCookie);
      const role = userData.role
      return role
    }
    return 'admin';
  })
  const [showDefault, setShowDefault] = useState(false)
  const [showConversationRecords, setShowConversationRecords] = useState(false)
  const [showCustomerRecods, setShowCustomerRecords] = useState(false)
  const [showEventRecords, setShowEventRecords] = useState(false)
  const [showEventDetailsPage, setShowEventDetailsPage] = useState(false)
  const [showDataSourcesPage, setShowDataSourcesPage] = useState(false)
  const [showContactPage, setShowContactPage] = useState(false)
  const [showOrganizationSettingsPage, setShowOrganizationSettingsPage] = useState(false)
  const [showProjectSettingsPage, setShowProjectSettingsPage] = useState(false)
  const [statusActive, setStatusActive] = useState(true)
  const [showAgentFeedbackOverall, setShowAgentFeedbackOverall] = useState(false)
  const [showAgentFeedbackAgentWise, setShowAgentFeebackAgentWise] = useState(false)
  const [showAgentFeedbackTeamWise, setShowAgentFeedbackTeamWise] = useState(false)
  const [showAgentFeedbackTraining, setShowAgentFeedbackTraining] = useState(false)
  const [showAgentFeedbackReports, setShowAgentFeedbackReports] = useState(false)
  const [showConcernQuery, setShowConcernQuery] = useState(false)
  const [showBusinessInsights, setShowBusinessInsights] = useState(false)
  const [showBillingDashboard, setShowBillingDashboard] = useState(false)
  const [showFormsList, setShowFormsList] = useState(false)
  const [activeProject, setActiveProject] = useState(true)
  const [client_id, setClient_id] = useState(null)
  const [showCallDetailsPage, setShowCallDetailsPage] = useState(false)
  const [showCustomerDetailsPage, setShowCustomerDetailsPage] = useState(false)
  const [updateStatusApi, setUpdateStatusApi] = useState(null)
  const [showIndividualReport, setShowIndividualReport] = useState(false)
  const [showTrainingDetails, setShowTrainingDetails] = useState(false)
  const [showConfiguration, setShowConfiguration] = useState(false)
  const [showDocumentation, setShowDocumentation] = useState(false)
  const [showVoiceAgents, setShowVoiceAgents] = useState(false)
  const [showCustomReports, setShowCustomReports] = useState(false)
  function getCookie(name) {
    function escape(s) { return s.replace(/([.*+?\^$(){}|\[\]\/\\])/g, '\\$1'); }
    var match = document.cookie.match(RegExp('(?:^|;\\s*)' + escape(name) + '=([^;]*)'));
    return match ? match[1] : null;
}
useEffect(()=> {
  if(client_id && selectedOptions){
    handleProjectStatus(true)
  }
}, [client_id, selectedOptions])

  const handleContactModal = (e) => {
    setShowContactPage(false)
    setOpenContact(false)
  }
  useEffect(() => {
    if(!dashNum){
      setIframeUrl(null)
        setComingSoon(false)
        setShowApps(false);
        setShowDefault(false);
        setShowConversationRecords(false);
        setShowCustomerRecords(false);
        setShowEventRecords(false);
        setShowEventDetailsPage(false);
        setShowDataSourcesPage(false);
        setShowContactPage(false)
        setShowOrganizationSettingsPage(false)
        setShowProjectSettingsPage(false)
        setShowAgentFeedbackOverall(false)
        setShowAgentFeebackAgentWise(false)
        setShowAgentFeedbackTeamWise(false)
        setShowAgentFeedbackTraining(false)
        setShowAgentFeedbackReports(false)
        setShowIndividualReport(false)
        setShowTrainingDetails(false)
        setShowConcernQuery(false)
        setShowBusinessInsights(false)
        setShowBillingDashboard(false)
        setShowFormsList(false)
        setActiveProject(false)
        setShowCallDetailsPage(false)
        setShowCustomerDetailsPage(false)
        setShowConfiguration(false)
        setShowDocumentation(false)
        setShowVoiceAgents(false)
        setShowCustomReports(false)
        if (openContact === true) {
          setShowContactPage(true);
        } else {
          setShowContactPage(false);
        }
      handleProjectStatus(true)
      switch (selectedMenu) {
        case 'Apps':
          setShowApps(true)
          return;
          case 'Home':
            setActiveProject(true)
            return;
            case 'Conversations':
              setShowConversationRecords(true)
              return;
              case 'Customers':
                setShowCustomerRecords(true)
                return;     
              case 'Events':
                setShowEventRecords(true)
                return;
              case 'Event ID':
                setShowEventDetailsPage(true)
                return;
                case 'Data Sources':
                  setShowDataSourcesPage(true)
                  return;  
                case 'Forms':
                  setShowFormsList(true)
                  return;
                case 'Organization Settings':
                  setShowOrganizationSettingsPage(true)
                  return; 
                case 'Project Settings':
                  setShowProjectSettingsPage(true)
                  return;
                case 'Custom Reports':
                  setShowCustomReports(true)
                  return;
                case 'Agent Feedback Overall':
                  setShowAgentFeedbackOverall(true)
                  return;
                case 'Agent Feedback Agent Wise':
                  setShowAgentFeebackAgentWise(true)
                  return;
                case 'Agent Feedback Team Wise':
                  setShowAgentFeedbackTeamWise(true)
                  return;
                case 'Agent Feedback Agent Training':
                  setShowAgentFeedbackTraining(true)
                  return;
                case 'Agent Feedback Reports':
                  setShowAgentFeedbackReports(true)
                  return;
                case 'Report ID':
                  setShowIndividualReport(true)
                  return;
                case 'Training ID':
                  setShowTrainingDetails(true)
                  return;
                case 'Concern Query':
                  setShowConcernQuery(true)
                  return;
                case 'Customer Insights':
                  setShowBusinessInsights(true)
                  return;
                case 'Billing':
                  setShowBillingDashboard(true)
                  return;
                case 'Call ID':
                  setShowCallDetailsPage(true)
                  return;
                case 'Customer ID':
                  setShowCustomerDetailsPage(true)
                  return;
                case 'Configuration':
                  setShowConfiguration(true)
                  return;
                case 'Documentation':
                  setShowDocumentation(true)
                  return;
                  case 'VA Home':
                  case 'VA Agents':
                  case 'VA Widgets':
                  case 'VA Agent ID':
                  case 'VA Conversations':
                  case 'VA Customers':
                  case 'VA Campaigns':
                  case 'VA Knowledge Base':
                  case 'VA Call ID':
                  case 'VA Customer ID':
                  case 'VA Campaign ID':
                  case 'VA Phone Number':
                    setShowVoiceAgents(true)
                    return;
        default:
          break;
      }
    }
    if(subSelectedMenu === 'Training' && selectedMenu === 'Agent Feedback'){
      setIframeUrl(null);
      setComingSoon(true);
      setIsLoading(false);
      return;
    }else{
      setComingSoon(false);
    }
    let clientId = '';
  }, [openContact, setOpenContact, subSelectedMenu, selectedMenu, selectedOptions, selectedClientId, email, client_id]);

  useEffect(()=> {
    const user = getCookie('dashboard_login_user_creds') ? JSON.parse(getCookie('dashboard_login_user_creds')) : null;
    if(selectedClientId){
      setClient_id(selectedClientId)
    }else{
      
      setClient_id(user.client_id)
    }
    setEmail(user?.email)
  }, [selectedClientId])
  const handleHideStatusBar = async (e) => {
    if(e){
      setStatusActive(false)
    }
  }
  const handleProjectStatus = async (e) => {
    if(e){
      try {
        if(!email || !client_id){
          return;
        }
        const resp = await server.getProjectStatus(client_id, selectedOptions, email, 'home', undefined, window.location.href);
        if(resp.status === 200){
          const data = await resp.json();
          if(data.data && data.data === 'completed'){
            setStatusActive(false);
          }else{
            setStatusActive(true)
          }
        }
      } catch (error) {
      }
    }
  }
  const updateStatus = async (status) => {
    setStatusActive(true)
    setUpdateStatusApi(status)
  }

  const isVoiceAgentLayout = selectedMenu?.startsWith("VA ");
  const viewportHeight = isVoiceAgentLayout ? "100dvh" : "100vh";

  return (
    <div className="flex-1" style={{background: "white", ...(isVoiceAgentLayout ? { minHeight: 0, overflow: "hidden" } : {})}}>
      {/* <div className="bg-white shadow-md p-6">
        <h1 className="text-3xl font-bold text-gray-700 mb-4">{selectedMenu} {subSelectedMenu}</h1>
      </div> */}
      {
        statusActive && role !== 'employee' && !showVoiceAgents && (
          <div className=" h-[50px]">
              <div className="absolute top-[64px] shadow-md"
                style={{
                  width: window.innerWidth - 252, // Adjust width dynamically
                  minWidth: window.innerWidth - 252, // Ensures it doesn’t break on small screens
                  zIndex: 1,
                }}>
                <ProjectStatusComponent serviceID={selectedOptions} clientID={client_id} dontShow={handleHideStatusBar} hitStatusApi={updateStatusApi} />
              </div>
          </div>
        )
      }


          {
            isLoading && (
              <div className="flex justify-center items-center" style={{ height: "88%", flexDirection: "column" }}>
                <div className="loader"></div>
                <div style={{textAlign: "center"}}>Loading <br/> Please Wait</div>
              </div>
            )
          }
      {
        comingSoon && (
          <div style={{textAlign: 'center', display: 'flex', justifyContent: 'center', alignItems: "center", flexDirection: 'column', height: "90%"}}>
            <h1 style={{fontSize: "51px"}}>Coming Soon</h1>
            <h3 style={{fontSize: "31px", color: "#b0b0b0"}}>We're working on something amazing. Stay tuned for more updates!</h3>
          </div>
        )
      }
      <div
        className="overflow-y-auto w-full"
        style={{
          height: statusActive && role !== 'employee' && showVoiceAgents ? `calc(${viewportHeight} - 64px)` : statusActive && role !== 'employee' ? `calc(${viewportHeight} - 64px - 4rem)` : (window.location.href.includes('?token=') ? viewportHeight : `calc(${viewportHeight} - 4rem)`), // 64px is the assumed top bar height
        }}
      >
      {
        activeProject && (
          <HomeScreen serviceID={selectedOptions} setSelectedMenu={setSelectedMenu} clientID={client_id}/>
        )
      }
      {
        showApps && (
          <AppsManagement serviceID={selectedOptions} clientID={client_id}/>
        )
      }
      {
        showConversationRecords && (
          <ConversationRecords serviceID={selectedOptions} clientID={client_id}/>
        )
      }
      {
        showCustomerRecods && (
          <CustomerRecords serviceID={selectedOptions} clientID={client_id}/>
        )
      }
      {
        showEventRecords && (
          <EventRecords serviceID={selectedOptions} clientID={client_id}/>
        )
      }
      {
        showEventDetailsPage && (
          <EventDetails selectedOption={selectedOptions} selectedClientId={client_id}/>
        )
      }
      {
        showDataSourcesPage && (
          <DataSourcesPage serviceID={selectedOptions} clientID={client_id} hitStatusApi={updateStatus}/>
        )
      }
      {
        showContactPage && <ContactsPage key={openContact} serviceID={selectedOptions} state={handleContactModal} clientID={client_id} />
      }
      {
        showOrganizationSettingsPage && (
          <OrganizationSettingsPage serviceID={selectedOptions} clientID={client_id}/>
        )
      }
      {
        showProjectSettingsPage && (
          <ProjectSettingsPage serviceID={selectedOptions} clientID={client_id}/>
        )
      }
      {
        showCustomReports && (
          <ReportsDashboard serviceID={selectedOptions} clientID={client_id}/>
        )
      }
      {
        showAgentFeedbackOverall && (
          <AgentFeedbackOverall serviceID={selectedOptions} clientID={client_id}/>
        )
      }
      {
        showAgentFeedbackAgentWise && (
          <AgentFeedbackAgentWise serviceID={selectedOptions} clientID={client_id}/>
        )
      }
      {
        showAgentFeedbackTeamWise && (
          <AgentFeedbackTeamWise serviceID={selectedOptions} clientID={client_id}/>
        )
      }
      {
        showAgentFeedbackTraining && (
          <AgentFeedbackTraining serviceID={selectedOptions} clientID={client_id}/>
        )
      }
      {
        showAgentFeedbackReports && (
          <AgentFeedbackReports serviceID={selectedOptions} clientID={client_id}/>
        )
      }
      {
        showConcernQuery && (
          <ConcernQueries serviceID={selectedOptions} clientID={client_id}/>
        )
      }
      {
        showBusinessInsights && (
          <BusinessInsights serviceID={selectedOptions} clientID={client_id}/>
        )
      }
      {
        showBillingDashboard && (
          <BillingDashboard serviceID={selectedOptions} clientID={client_id}/>
        )
      }
      {
        showFormsList && (
          <FormsList />
        )
      }
      {
        showCallDetailsPage && (
          <CallDetails selectedOption={selectedOptions} selectedClientId={client_id}/>
        )
      }
      {
        showCustomerDetailsPage && (
          <CustomerDetails selectedOption={selectedOptions} selectedClientId={client_id}/>
        )
      }
      {
        showIndividualReport && (
          <IndividualReport serviceID={selectedOptions} clientID={client_id}/>
        )
      }
      {
        showTrainingDetails && (
          <IndividualTraining serviceID={selectedOptions} clientID={client_id}/>
        )
      }
      {
        showConfiguration && (
          <DeveloperHubConfiguration serviceID={selectedOptions} clientID={client_id}/>
        )
      }
      {
        showDocumentation && (
          <DeveloperHubDocumentation serviceID={selectedOptions} clientID={client_id}/>
        )
      }
      {
        showVoiceAgents && (
          <VoiceAgentsDashboard 
            selectedMenu={selectedMenu}
            selectedClientId={client_id}
            selectedOptions={selectedOptions}
            openContact={openContact}
            setOpenContact={setOpenContact}
          />
        )
      }
      </div>
    </div>
  );
};

export default Dashboard;
